import { Header } from 'antd/es/layout/layout';
import { FC, ReactNode } from 'react';
import styles from './TrojanHeader.module.css';

interface TrojanHeaderProps {
  children: ReactNode;
}
const TrojanHeader: FC<TrojanHeaderProps> = ({ children }) => {
  return <Header className={styles.header}>{children}</Header>;
};

export default TrojanHeader;
